import React from 'react';
import PropTypes from 'prop-types';
import { useStaticValues } from '@stateManagement/StaticValuesContext';
import { PageHelmet } from '../../components/PageHelmet';
import { ScriptHelmet } from '@components/ScriptHelmet';
import geotabShare from '@images/geotabShareImage.jpg';

function truncateDescription(bio) {
    const seoDescriptionLimit = 120;

    if (bio.length < seoDescriptionLimit) {
        return bio;
    } else {
        const lastSentenceIndex = bio.substring(0, seoDescriptionLimit).lastIndexOf('.');
        if (lastSentenceIndex === -1) {
            return bio.substring(0, seoDescriptionLimit);
        } else {
            return bio.substring(0, lastSentenceIndex + 1);
        }
    }
}

function getAuthorSeo(blog, authorTranslation) {
    return {
        title: authorTranslation
            ? `${authorTranslation} - ${blog.authorPageData.author.name}`
            : blog.authorPageData.author.name,
        description: blog.authorPageData.author.shortBiography
            ? truncateDescription(blog.authorPageData.author.shortBiography)
            : `${blog.authorPageData.author.name} have written blog articles for Geotab.`,
        canonical: blog.authorPageData.author.canonical,
        datePublished: blog.authorPageData.author.publishedDateUtc,
        dateModified: blog.authorPageData.author.modifiedDateUtc,
    };
}

function getArticleHeaderImage(article, articleType, prefixStringWithBaseUrl) {
    if (article.articleData[articleType] && article.articleData[articleType].imageUrl) {
        return prefixStringWithBaseUrl(article.articleData[articleType].imageUrl);
    } else {
        return prefixStringWithBaseUrl(geotabShare);
    }
}

function getArticleSectionSeo(isAuthorPage, article, articleType, prefixStringWithBaseUrl, authorTranslation) {
    if (isAuthorPage && article.authorPageData && article.authorPageData.author) {
        return getAuthorSeo(article, authorTranslation);
    } else {
        return {
            title: article.articleData[articleType].pageTitle
                ? article.articleData[articleType].pageTitle
                : article.articleData[articleType].title,
            description: article.articleData[articleType].metaDescription
                ? article.articleData[articleType].metaDescription
                : article.articleData[articleType].description,
            imageUrl: getArticleHeaderImage(article, articleType, prefixStringWithBaseUrl),
            canonical: article.articleData[articleType].canonical,
            dateModified: article.articleData[articleType].modifiedDateUtc,
            datePublished: article.articleData[articleType].publishedDateUtc,
        };
    }
}

export function ArticleSectionPageHelmet({
    isAuthorPage = false,
    noIndex = false,
    article,
    articleType,
    script,
    authorTranslation,
}) {
    const { prefixStringWithBaseUrl } = useStaticValues();
    const seo = getArticleSectionSeo(isAuthorPage, article, articleType, prefixStringWithBaseUrl, authorTranslation);

    return (
        <>
            <PageHelmet seo={seo} noIndex={noIndex} />
            {script ? <ScriptHelmet script={script} /> : null}
        </>
    );
}

ArticleSectionPageHelmet.propTypes = {
    isAuthorPage: PropTypes.bool,
    noIndex: PropTypes.bool,
    articleType: PropTypes.string,
    article: PropTypes.objectOf(Object).isRequired,
    script: PropTypes.shape({
        type: PropTypes.string,
        body: PropTypes.string,
    }),
    authorTranslation: PropTypes.string,
};
